type ViewWidgetSettingsProps = {
    showUpcomingMeetings: boolean;
    showTodo: boolean;
    showDocuments: boolean;
    showLinks: boolean;
    showNotes: boolean;
};

export default class ViewWidgetSettings {
    showUpcomingMeetings: boolean;

    showTodo: boolean;

    showDocuments: boolean;

    showLinks: boolean;

    showNotes: boolean;

    constructor({
        showUpcomingMeetings,
        showTodo,
        showDocuments,
        showLinks,
        showNotes,
    }: ViewWidgetSettingsProps) {
        this.showUpcomingMeetings = showUpcomingMeetings;
        this.showTodo = showTodo;
        this.showDocuments = showDocuments;
        this.showLinks = showLinks;
        this.showNotes = showNotes;
    }
}
